export default {
    head() {
        return {
            title: this.meta.title,
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content: this.meta.description
                }
            ]
        };
    },
    async asyncData({ route, store }) {
        const data = await store.dispatch("FetchPageDescriptions", {
            code: route.path
        });

        return {
            meta: data.data
        };
    }
};
